import useSWR from 'swr';

import { WorkloadType } from '@/components/Workload/types';
import { cleanObject } from '@/utils';

import { GetWorkloadListParams, getDeploymentList } from '../api';
import { getDaemonSetList } from '../api/daemonset.api';
import { getStatefulSetList } from '../api/statefulset.api';
import { WorkloadFetch } from '../constants';

const { DEPLOYMENT, STATEFULSET, DAEMONSET } = WorkloadType;

type FetchParams = GetWorkloadListParams;

/** 内部挟带了 cluster */
export const useWorkloads = (module: WorkloadType, cluster: string, params?: FetchParams) => {
  const swrKey = { key: WorkloadFetch.LIST, module, cluster, params };
  const {
    data: response,
    error,
    isLoading,
    isValidating,
    mutate,
  } = useSWR(swrKey, fetchWorkloadList, {
    refreshInterval: 0, // 轮询统一由列表的 ResourceTable 调度
    dedupingInterval: 0, // 禁用去重，确保每次调用都发送新请求
  });

  return {
    response,
    error,
    isLoading,
    isValidating,
    mutate,
  };
};

const apiFunctionMap: Record<WorkloadType, (cluster: string, params?: FetchParams) => Promise<any>> = {
  [DEPLOYMENT]: getDeploymentList,
  [STATEFULSET]: getStatefulSetList,
  [DAEMONSET]: getDaemonSetList,
};

/** 按工作负载类型复用原列表 API，供统一列表与旧 Hook 共用。 */
export async function fetchWorkloadList({ module, cluster, params }: { module: WorkloadType; cluster: string; params?: FetchParams }) {
  // 根据 module 查找对应的 API 函数
  const fetcherFunction = apiFunctionMap[module];

  if (!fetcherFunction) {
    // 如果找不到对应的函数，可以抛出错误或返回默认值/调用通用函数
    return getDeploymentList(cluster, cleanObject(params)); // 或者调用通用函数
  }

  // 调用选定的 API 函数
  return fetcherFunction(cluster, cleanObject(params));
}
